import { TShuttle, TVessel } from "~/types";
import { baseService } from "../base";
import { CreateVesselParams } from "../operation";
import { PaginationResponse, QueryParams } from "../type";
import {
  CreateShuttleParams,
  TVesselType,
  UpdateShuttleParams,
  UpdateVesselParams,
} from "./vessel.types";

const serializeQueryParams = (params?: QueryParams): string => {
  if (!params) return "";

  const searchParams = new URLSearchParams();

  const serialize = (obj: any, prefix?: string) => {
    for (const key in obj) {
      if (obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
        const k = prefix ? `${prefix}[${key}]` : key;
        const v = obj[key];

        if (typeof v === "object" && !Array.isArray(v)) {
          serialize(v, k);
        } else {
          searchParams.append(k, v.toString());
        }
      }
    }
  };

  serialize(params);
  return searchParams.toString();
};


export const vesselServices = {
  getAllVessel: async (params?: QueryParams) => {
    const paramsWithGetAll = {
      ...params,
      getAll: true  // THIS IS THE KEY FIX - skips expensive joins!
    };

    const queryString = serializeQueryParams(paramsWithGetAll);
    const url = queryString ? `/vessels?${queryString}` : "/vessels?getAll=true";

    const { data } = await baseService.get<PaginationResponse<TVessel>>(url);
    return data;


  },

  getVesselsForDropdown: async () => {
    const { data } = await baseService.get<TVessel[]>("/vessels/dropdown");
    return data;
  },

  getVesselAssignments: async () => {
    const { data } = await baseService.get<TVessel[]>("/vessels/assignments");
    return data;
  },

  getTodayVesselAssignments: async () => {
    const { data } = await baseService.get<TVessel[]>("/vessels/today-assignments");
    return data;
  },

  getVesselLoadLists: async (params?: QueryParams) => {
    const queryString = serializeQueryParams(params);
    const url = queryString ? `/vessels/load-lists?${queryString}` : "/vessels/load-lists";
    const { data } = await baseService.get<PaginationResponse<TVessel>>(url);
    return data;
  },
  
  getVesselLoadList: async (vesselId: string, params?: QueryParams) => {
    const queryString = serializeQueryParams(params);
    const url = queryString ? `/vessels/${vesselId}/load-list?${queryString}` : `/vessels/${vesselId}/load-list`;
    const { data } = await baseService.get<TVessel>(url);
    return data;
  },

  getVesselById: async (id: string) => {
    const { data } = await baseService.get<TVessel>(`/vessels/${id}`);
    return data;
  },
  createVessel: async (body: CreateVesselParams) => {
    const { data } = await baseService.post("/vessels", body);
    return data;
  },
  deleteVessel: async (id: string) => {
    const { data } = await baseService.delete(`/vessels/${id}`);
    return data;
  },
  updateVessel: async ({
    id,
    ...body
  }: UpdateVesselParams & { id: string }) => {
    const { data } = await baseService.patch(`/vessels/${id}`, body);
    return data;
  },

  getVesselTypes: async (params?: QueryParams) => {
    const { data } = await baseService.get<PaginationResponse<TVesselType>>(
      "/vessel-types",
      { params }
    );
    return data;
  },

  getShuttles: async (params?: QueryParams) => {
    const { data } = await baseService.get<PaginationResponse<TShuttle>>(
      "/shuttles",
      { params }
    );
    return data;
  },

  getShuttleById: async (id: string) => {
    const { data } = await baseService.get<TShuttle>(`/shuttles/${id}`);
    return data;
  },

  createShuttle: async (body: CreateShuttleParams) => {
    const { data } = await baseService.post("/shuttles", body);
    return data;
  },

  updateShuttle: async ({
    id,
    ...body
  }: UpdateShuttleParams & { id: string }) => {
    const { data } = await baseService.patch(`/shuttles/${id}`, body);
    return data;
  },

  deleteShuttle: async (id: string) => {
    const { data } = await baseService.delete(`/shuttles/${id}`);
    return data;
  },
};
